import moment from "moment";
import { IExpiryConfig } from "../../types/IExpiryConfig";

const DATE_FORMAT = "DD-MMMM-YYYY";

const ExpiryReceipt = ({ expiryConfig }: { expiryConfig: IExpiryConfig }) => {
  const now = moment();
  const expiryDate = now.clone().add(expiryConfig.shelf_life_in_days, "days");

  return (
    <div style={{ fontSize: 14, fontFamily: "sans-serif" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 14 }}>
          <strong>{expiryConfig.title}</strong>
        </div>
        <div>
          <span>
            <strong>Date: </strong>
            {now.format(DATE_FORMAT)}
          </span>
          <br />
          <span>
            <strong>Expiry: </strong>
            {expiryDate.format(DATE_FORMAT)}
          </span>
          <br />
        </div>
      </div>
    </div>
  );
};

export default ExpiryReceipt;
